import { useEffect } from 'react';
import { useEvent } from './useEvent';
import { usePrevious } from './usePrevious';
var INITIAL_VALUE = Symbol('Initial value');
/** Hook that triggers a callback when the observable property changes */
export function useChange(observer, observable) {
    var prevObservable = usePrevious(observable, INITIAL_VALUE);
    var stableObserver = useEvent(observer);
    useEffect(function () {
        if (prevObservable !== INITIAL_VALUE && prevObservable !== observable) {
            stableObserver(observable, prevObservable);
        }
    }, [prevObservable, observable, stableObserver]);
}
//# sourceMappingURL=useChange.js.map